var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _g2, _path13, _path14, _path15, _g3, _path16, _path17, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_4985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_4985",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_4985)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6292 6.81986C13.6292 6.81986 6.11608 7.99266 6.6858 18.673C6.68786 18.7126 5.81707 19.2894 5.74891 19.351C5.14168 19.8989 4.63229 20.6005 4.4095 21.4212C3.61625 24.3439 6.45232 27.3553 8.74571 28.1546C9.60238 28.4532 10.5078 28.5981 11.4151 28.6244C17.3129 28.7958 25.1214 25.0561 25.5224 17.7528C25.5367 17.491 25.5404 17.2288 25.5335 16.9668C25.498 15.5801 25.1625 14.2295 24.6569 12.9755C24.6571 12.9756 21.3747 4.85322 13.6292 6.81986Z",
    fill: "#FFE4C0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49563 18.7857C6.577 18.9846 6.65826 19.2388 6.68097 19.3841C6.77783 20.0076 6.56402 20.6514 6.19262 21.1142C5.83991 21.5536 5.33624 21.8386 4.84847 21.9461C4.68378 21.9824 4.48438 22.001 4.31003 22.0069C4.49325 20.2013 5.9668 19.118 6.49563 18.7857ZM17.0863 23.5312C15.6907 23.2316 14.8242 21.7647 15.151 20.2547C15.4777 18.7447 16.8739 17.7634 18.2695 18.063C19.665 18.3625 20.5315 19.8294 20.2048 21.3394C19.878 22.8494 18.4818 23.8307 17.0863 23.5312Z",
    fill: "#DC2400"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.254 19.3075C10.254 19.3075 9.06221 18.1762 8.13956 19.2399L10.254 19.3075Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3667 24.9446C25.3341 26.9282 28.935 21.954 27.7816 19.1579C27.0458 17.3743 24.9007 17.2356 23.6576 18.8648C22.924 19.8263 22.3304 21.0554 21.9934 22.2311",
    fill: "#FFE4C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.6345 20.5057C24.124 21.0239 23.7136 21.7924 23.2093 22.221C23.3025 21.5037 23.4513 20.7378 23.8006 20.0913C24.1552 19.4348 24.8001 18.8939 25.4567 18.9385C26.2704 18.9938 26.9404 19.9393 27.0266 20.7966C26.9751 20.2836 25.9407 19.9364 25.5459 19.985C24.9276 21.1475 24.6883 23.4387 24.6883 23.4387C24.1732 22.1417 24.3818 21.1214 24.6345 20.5057Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88148 20.7599C8.85089 20.7588 8.8204 20.7639 8.79181 20.7748C8.76322 20.7857 8.73713 20.8023 8.71509 20.8235C8.47708 21.0528 8.06248 21.3493 7.60492 21.491C7.15369 21.6307 6.68752 21.6145 6.28643 21.2706C6.26375 21.2509 6.23737 21.2358 6.20883 21.2263C6.18029 21.2168 6.15015 21.213 6.12015 21.2152C6.09014 21.2174 6.06087 21.2255 6.03401 21.239C6.00715 21.2526 5.98325 21.2713 5.96367 21.2942C5.94409 21.317 5.92923 21.3435 5.91994 21.3722C5.91065 21.4008 5.90712 21.431 5.90954 21.461C5.91197 21.491 5.92031 21.5202 5.93409 21.5469C5.94786 21.5737 5.96679 21.5975 5.98979 21.6169C6.54598 22.0938 7.19095 22.0966 7.73974 21.9266C8.1814 21.7898 8.57788 21.5377 8.85828 21.3059C10.9396 23.4528 13.5564 22.8156 14.6263 22.2124C14.6789 22.1827 14.7177 22.1333 14.7339 22.0751C14.7502 22.0168 14.7426 21.9545 14.7129 21.9018C14.6833 21.8491 14.6339 21.8104 14.5756 21.7941C14.5174 21.7779 14.4551 21.7854 14.4025 21.8151C13.4097 22.3749 10.9497 22.9597 9.04279 20.8354C9.02235 20.8127 8.99754 20.7942 8.96982 20.7813C8.9421 20.7683 8.91206 20.761 8.88148 20.7599Z",
    fill: "#592125"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0541 17.4811C12.0554 18.158 12.4089 18.7074 13.1431 18.5948C13.6715 18.4532 14.0233 18.0807 14.022 17.3708C14.0205 16.627 13.5874 16.1443 13.1383 16.1434C12.5381 16.1423 12.0528 16.8041 12.0541 17.4811ZM7.04911 17.4689C7.04996 17.9226 7.25532 18.4099 7.78086 18.3538C8.22184 18.3069 8.33443 17.7278 8.33386 17.4427C8.33289 16.9442 8.08315 16.4731 7.71875 16.4724C7.32689 16.4717 7.04819 17.0151 7.04911 17.4689Z",
    fill: "#2A1200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7254 14.2733C12.4332 13.9226 13.3175 13.9552 14.0274 14.3551C14.2562 14.484 14.404 14.7922 14.2867 15.0534C14.1784 15.295 13.8928 15.4467 13.6477 15.3084C13.5747 15.2669 13.4994 15.2297 13.4221 15.1969C13.3981 15.1867 13.3363 15.1747 13.3124 15.1562C13.3011 15.1529 13.2902 15.1496 13.2788 15.1465C13.2092 15.1277 13.1386 15.1125 13.0673 15.1008C13.0268 15.0943 12.986 15.0889 12.9452 15.0847C12.9323 15.0834 12.9195 15.0824 12.9065 15.0813C12.8731 15.0856 12.8314 15.0796 12.8001 15.0807C12.6881 15.0844 12.5766 15.0973 12.4666 15.1193C12.4568 15.1213 12.4473 15.1234 12.4375 15.1256C12.401 15.137 12.3644 15.1476 12.3283 15.1603C12.2515 15.1878 12.1764 15.2199 12.1033 15.2562C11.8746 15.3696 11.5519 15.2094 11.4646 14.9512C11.3688 14.6668 11.4803 14.3948 11.7254 14.2733ZM6.79181 14.5198C7.21507 14.29 7.7006 14.2383 8.13765 14.3646C8.2556 14.3987 8.36324 14.5014 8.41372 14.6151C8.46353 14.727 8.47361 14.8874 8.42461 15.0091C8.37361 15.1355 8.28654 15.2558 8.16386 15.3157C8.03947 15.3765 7.91229 15.3922 7.78414 15.3554C7.76317 15.3493 7.74169 15.3458 7.72032 15.3407C7.65368 15.3333 7.58656 15.331 7.51957 15.3341C7.43855 15.3463 7.35877 15.3661 7.27997 15.3932C7.2525 15.4058 7.22447 15.417 7.19757 15.4315C7.08167 15.4944 6.9366 15.5094 6.8179 15.4712C6.70428 15.4346 6.5877 15.3369 6.54194 15.2204C6.49448 15.0999 6.47858 14.9566 6.53106 14.8264C6.58331 14.6965 6.66918 14.5863 6.79181 14.5198Z",
    fill: "#71472D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34609 12.4861C8.87365 12.961 8.22783 13.2535 7.51562 13.2535C7.4351 13.2535 7.35538 13.2498 7.27675 13.2424C6.98945 14.2261 6.79435 15.358 6.73195 16.6599C5.85011 16.262 5.23619 15.3735 5.23619 14.3413C5.23619 13.6954 5.4766 13.1058 5.87262 12.6575C5.27602 12.1625 4.8943 11.404 4.8943 10.5536C4.8943 9.23176 5.8166 8.13174 7.03452 7.89907C7.02144 7.78329 7.0149 7.66686 7.01492 7.55035C7.01492 5.90845 8.30714 4.57747 9.90125 4.57747C10.3212 4.57704 10.7358 4.67091 11.1148 4.85218C11.5444 3.76586 12.5799 3 13.789 3C14.7907 3 15.6732 3.5256 16.1909 4.32361C16.6784 3.94965 17.2847 3.72806 17.9418 3.72806C19.1358 3.72806 20.1621 4.45965 20.613 5.50707C20.9849 5.33393 21.3901 5.24444 21.8002 5.24488C23.3769 5.24488 24.6584 6.54713 24.686 8.16435C26.2004 8.272 27.3962 9.55861 27.3962 11.13C27.3962 11.8854 27.1198 12.5751 26.6645 13.0995C27.224 13.6412 27.5729 14.4069 27.5729 15.2556C27.5729 16.8975 26.2674 18.2286 24.6571 18.2286C24.5503 18.2286 24.4435 18.2227 24.3374 18.2109C22.9617 19.035 22.2679 20.7008 22.0742 21.5945C22.0742 21.5945 21.4284 21.6326 21.2764 21.5088C20.6452 21.1775 19.6251 20.0332 19.5768 17.8271C19.023 17.2859 18.6781 16.5242 18.6781 15.6804C18.6778 15.3767 18.7232 15.0746 18.8128 14.7845C17.9255 14.5345 17.2079 13.8676 16.8756 13.0035C16.5068 13.1688 16.1074 13.254 15.7034 13.2535C14.757 13.2535 13.9158 12.7937 13.3831 12.0812C12.9053 12.7892 12.1044 13.2535 11.1972 13.2535C10.477 13.2535 9.82382 12.961 9.34609 12.4861Z",
    fill: "var(--primary-dark-color)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3039 6.56169C19.6676 5.58577 17.1262 7.40191 15.902 8.45122C17.5665 8.34671 18.4776 10.5775 18.7741 11.6686C19.2995 12.1848 20.1705 12.2788 20.5244 12.2794C20.716 10.7802 20.9402 7.53761 20.3039 6.56169Z",
    fill: "#A09B9B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_116_4985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 6,
    width: 6,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3039 6.56169C19.6676 5.58577 17.1262 7.40191 15.902 8.45122C17.5665 8.34671 18.4776 10.5775 18.7741 11.6686C19.2995 12.1848 20.1705 12.2788 20.5244 12.2794C20.716 10.7802 20.9402 7.53761 20.3039 6.56169Z",
    fill: "#A09B9B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_116_4985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6702 12.0437C20.2311 11.8789 19.6756 11.6961 19.4527 11.6252L20.8805 11.1161L20.6702 12.0437ZM21.0304 10.5667L21.0637 9.95227L20.0443 10.3076L21.0304 10.5667Z",
    fill: "#C4C4C4"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.902 8.45127C17.5257 9.00828 18.4918 10.8055 18.772 11.6345C20.0423 10.0446 20.6899 7.25822 20.0289 6.54467C19.5001 5.97384 17.0573 7.57793 15.902 8.45127Z",
    fill: "#FEB3A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_116_4985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 6,
    width: 6,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.902 8.45127C17.5257 9.00828 18.4918 10.8055 18.772 11.6345C20.0423 10.0446 20.6899 7.25822 20.0289 6.54467C19.5001 5.97384 17.0573 7.57793 15.902 8.45127Z",
    fill: "#FEB3A4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_116_4985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.957 7.9104C19.161 7.88967 18.9594 10.433 18.708 11.7072L15.5631 8.50693C15.8594 8.31669 16.7529 7.93108 17.957 7.9104Z",
    fill: "#FFE7E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_116_4985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 7,
    height: 6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06692 11.0814C9.0641 9.22524 10.6311 7.85457 12.0841 7.16923L9.69089 6.51245L6.98428 7.22634L8.06692 11.0814Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_116_4985)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1768 6.78963C8.41673 6.81761 8.36043 8.98082 8.42425 10.0855C9.02688 9.05821 10.5498 9.31732 11.2359 9.53274C11.7124 9.40567 12.1053 8.92143 12.2454 8.71126C11.5392 8.05904 9.93693 6.76165 9.1768 6.78963Z",
    fill: "#A09B9B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_116_4985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 5,
    height: 5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1768 6.78963C8.41673 6.81761 8.36043 8.98082 8.42425 10.0855C9.02688 9.05821 10.5498 9.31732 11.2359 9.53274C11.7124 9.40567 12.1053 8.92143 12.2454 8.71126C11.5392 8.05904 9.93693 6.76165 9.1768 6.78963Z",
    fill: "#A09B9B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_116_4985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1801 8.53988C11.9208 8.74183 11.6061 9.00648 11.4812 9.11356L11.7794 8.08179L12.1801 8.53988ZM11.5521 7.79549L11.2449 7.55505L11.0277 8.28876L11.5521 7.79549Z",
    fill: "#C4C4C4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40884 10.5387C9.34031 9.77321 10.6743 9.39068 11.2172 9.52169C10.8896 8.19556 9.6924 6.81016 9.05934 6.947C8.55294 7.05648 8.40952 9.53819 8.40884 10.5387Z",
    fill: "#FEB3A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_116_4985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 4,
    height: 5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40884 10.6244C9.34031 9.85888 10.6743 9.39068 11.2172 9.52169C10.8896 8.19556 9.69234 6.81016 9.05934 6.947C8.55294 7.05648 8.40952 9.62386 8.40884 10.6244Z",
    fill: "#FEB3A4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_116_4985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90351 8.75455C9.44027 7.90805 10.6652 8.97791 11.2106 9.61859L8.12378 10.6405C8.16002 10.3646 8.36675 9.60106 8.90351 8.75455Z",
    fill: "#FFE7E2"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_4985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAvatar);
export default __webpack_public_path__ + "static/media/img-avatar.259f395a0329f382fceec1aab85960fa.svg";
export { ForwardRef as ReactComponent };